import * as React from 'react';
import { flow, forEach, isUndefined } from 'lodash';
import { destroy } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { IHeaderActions } from './models';
import { withRouter} from 'react-router';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { Col, Row } from 'react-bootstrap';
import { IStore } from '../../../../redux/IStore';
import { actions as headerActions } from './reducer';
import { IChannel } from '../../../../data/api/models';
import { IAuthState } from '../../../../services/auth/models';
import { IQuoteActions } from '../../../../services/quote/models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { FaHome } from 'react-icons/lib/fa';

interface IHeaderProps {
  classes: any;
  isDrawerOpened: boolean;
  actions: {
    auth: IAuthActions;
    quote: IQuoteActions;
    header: IHeaderActions;
    destroy(formName: string);
    push: (route: string) => void;
  };
  steps: object;
  location: any;
  auth: IAuthState;
  channel: IChannel;
}

interface IHeaderState {
  showModal: boolean;
}

class Header extends React.Component<IHeaderProps, IHeaderState> {
  private handleLogoClick = () => {
    const { actions } = this.props;

    actions.quote.reset();
    actions.destroy('quote');
    window.location.href = 'https://';
  }

  private renderLogo = () => {
    const { channel } = this.props;

    return (
      <div className="logo-container">
        <div className="logo-link" onClick={this.handleLogoClick}>
          <img src={require('./img/logo.png')} alt={channel.baseName} />
        </div>
      </div>
    );
  }

  private handleHomeClick = () => {
    const { actions, location, steps } = this.props;
    let resetForm = true;

    forEach(steps, (step) => {
      if (step.route === location.pathname && !isUndefined(step.keepDataWhenLeaving)) {
        resetForm = step.keepDataWhenLeaving !== true;
      }
    });

    if (resetForm === true) {
      actions.destroy('quote');
      actions.quote.reset();
    }

    actions.push('/');
  }

  public render() {
    const { auth } = this.props;

    return (
      <header>
        <div className="main-header">
          <div className="container">
            <Row>
              <Col md={4}>
                  {this.renderLogo()}
              </Col>
              <Col md={8}>
                <div className="header-title">
                  <h1>Horsebox Insurance</h1>
                  <div className="main-header-links">
                    <ul>
                      <li>
                        <a onClick={this.handleHomeClick} className="main-header-link">
                          <FaHome />
                        </a>
                      </li>
                      <li>
                        <Link to="/cookies" className="main-header-link">
                          Cookie Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/auth/login" className="main-header-link">
                          {auth.isAuthenticated ? 'My Account' : 'Login'}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </header>
    );
  }
}

export default flow([
  connect(
    (state: IStore) => ({
      auth: state.auth,
      channel: state.branding.channel,
      isDrawerOpened: state.header.isDrawerOpened,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        header: bindActionCreators({ ...headerActions }, dispatch),
      },
    }),
  ),
  withRouter,
])(Header);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/scenes/Header/index.tsx